<template>
  <a-modal
    v-model="visible"
    title="Edit Parent"
    :confirmLoading="loading"
    okText="Update"
    @ok="submit"
    @cancel="handleCancel"
    destroyOnClose
  >
    <a-form class="mb-4" :form="form">
      <a-form-item label="Parent's/Guardian's Name">
        <a-input
          placeholder="Name"
          v-decorator="['name', {
            initialValue: (parent && parent.name) || '',
            rules: [
              { required: false, message: 'Please input name!' },
              { max: 30, message: 'Must not exceed 30 characters!' }
            ]
          }]"
        />
      </a-form-item>

      <a-form-item label="Phone">
        <a-input
        placeholder="Phone Number"
        disabled
        style="background-color: #f5f5f5; color: rgba(0, 0, 0, 0.65);"
        v-decorator="['phone', {
        initialValue: (parent && parent.phone) || '',
        }]"
      />
      </a-form-item>

      <a-form-item label="Email">
        <a-input
          placeholder="Email of parent/guardian"
          v-decorator="['email', {
            initialValue: (parent && parent.email) || '',
            rules: [
              { required: false, message: 'Please input email!' },
              { type: 'email', message: 'Invalid email!' }
            ]
          }]"
        />
      </a-form-item>
      <a-form-item label="Password">
          <a-input-password
            type="password"
            placeholder="Password"
            v-decorator="['password', { rules: [{required: false, message: 'Please input a password!',},{
                            validator: validateToNextPassword,
                          }]}]"
          />
        </a-form-item>
        <a-form-item label="Confirm password">
          <a-input-password
            type="password"
            placeholder="Confirm password"
            v-decorator="['confirm_password', { rules: [{required: false, message: 'Please input a password!'},{
                            validator: compareToFirstPassword,
                          }]}]"
          />
        </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'EditRegisteredParent',
  props: {
    parent: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: this.$form.createForm(this),
    }
  },
  methods: {
    showModal() {
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: (this.parent && this.parent.name) || '',
          phone: (this.parent && this.parent.phone) || '',
          email: (this.parent && this.parent.email) || '',
          password: '',
        })
      })
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(new Error('Not same with the password!'))
      } else {
        callback()
      }
    },

    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // Remove confirm_password (always frontend-only)
          delete values.confirm_password

          // Remove password if left blank
          if (!values.password) delete values.password

          // Compare with original parent data — send only changed fields
          const payload = {}
          for (const key in values) {
            if (values[key] !== this.parent[key] && values[key] !== undefined) {
              payload[key] = values[key]
            }
          }
          values.registered_parent_id = this.parent.id
          this.loading = true
          this.$http.patch(`/api/parent/single/registration/${this.parent.id}`, payload)
            .then(() => {
              this.$notification.success({
                message: 'Parent updated successfully!',
              })
              this.visible = false
              this.$emit('updated')
              this.form.resetFields()
            })
            .catch((err) => {
              const response = err

              if (response && response.errors) {
                // Set field errors directly in the form
                const fieldErrors = {}
                for (const field in response.errors) {
                  fieldErrors[field] = {
                    errors: response.errors[field].map(msg => new Error(msg)),
                  }
                }
                this.form.setFields(fieldErrors)
                this.$notification.error({
                  message: 'Validation Error',
                  description: fieldErrors[Object.keys(fieldErrors)[0]].errors[0].message,
                })
              } else {
                this.$notification.error({
                  message: 'Error updating parent',
                  description: (response && response.message) || 'An error occurred.',
                })
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
